import RecoverPassword from './components/RecoverPassword.vue';
import NewPassword from './components/NewPassword.vue';
import Terms from './components/Terms.vue';
import NotFound from './components/NotFound.vue';
import SpecieDetails from './components/SpecieDetails/SpecieDetails.vue';

const routes = [
  {
    path: '/recover-password',
    component: RecoverPassword,
  },
  {
    path: '/recover-password/:user/:hash',
    component: NewPassword,
  },
  {
    path: '/terms',
    component: Terms,
  },
  {
    path: '/qr/:id',
    component: SpecieDetails,
  },
  {
    path: '*',
    component: NotFound,
  },
];

export default routes;
